var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconParkSolidReverseLens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-solid:reverse-lens"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_298_1246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 30,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66699 16.667V6.66699H12.667L14.0003 4.66699H18.0003L19.3337 6.66699H23.3337V16.667H8.66699Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.333 23.334L15.9997 26.0007L13.333 28.6673",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3333 25.4457C26.0427 24.417 30 22.067 30 19.3337C30 17.8323 29.008 16.447 27.3333 15.333M16 26.0003C8.636 26.0003 2 23.0157 2 19.3337C2 17.8323 2.992 16.447 4.66667 15.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16 13.334C16.5304 13.334 17.0391 13.1233 17.4142 12.7482C17.7893 12.3731 18 11.8644 18 11.334C18 10.8036 17.7893 10.2948 17.4142 9.91977C17.0391 9.5447 16.5304 9.33398 16 9.33398C15.4696 9.33398 14.9609 9.5447 14.5858 9.91977C14.2107 10.2948 14 10.8036 14 11.334C14 11.8644 14.2107 12.3731 14.5858 12.7482C14.9609 13.1233 15.4696 13.334 16 13.334Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_298_1246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0 0H32V32H0V0Z",
    fill: "#919191"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkSolidReverseLens);
export default __webpack_public_path__ + "static/media/icon-park-solid-reverse-lens.2ee86a5d3094d1a2d278bb0912c98356.svg";
export { ForwardRef as ReactComponent };